module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "white"
  }, [_c('v-row', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-col', {
    attrs: {
      "xs12": "",
      "sm7": ""
    }
  }, [_c('div', {
    staticClass: "ma-3 pa-3 white text-align-center"
  }, [_c('h5', [_vm._v("Welcome to Taco")]), _vm._v(" "), _c('img', {
    attrs: {
      "width": "120 ",
      "src": "/static/images/taco.jpg"
    }
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("This page is going to look awesome when I think of something cool and witty to say here.")])])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs12": "",
      "sm5": ""
    }
  }, [(_vm.signInEnabled) ? _c('div', {
    staticClass: "ma-3 pa-3 grey lighten-2 text-align-center"
  }, [_c('v-btn', {
    staticClass: "primary",
    attrs: {
      "disabled": !_vm.signInEnabled
    },
    nativeOn: {
      "click": function($event) {
        return _vm.signIn($event)
      }
    }
  }, [_vm._v("\n                    Login with Google\n                ")])], 1) : _c('div', {
    staticClass: "ma-3 pa-3 grey lighten-2 text-align-center"
  }, [_c('v-progress-circular', {
    staticClass: "primary--text",
    attrs: {
      "indeterminate": ""
    }
  }), _vm._v(" "), _c('br')], 1)])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "400px"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-143e7f29"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Welcome.vue
// module id = 2459
// module chunks = 1